import React from 'react';
import RecoItem from './RecoItem';
import { Configuration } from '../../../configs/Configuration';
import { WIDGETS } from '../../../constants/common';

class Marketplace extends React.Component{
    render(){
        let colorsData = Configuration.getColors().colors;
        return(
            <>
                {this.props.hideTitle !== true &&
                    <div className="marketplace-title" data-widget-name={WIDGETS.MARKETPLACE} data-text-color="color_2">
                        {this.props.translations.data["DASHBOARD.MARKETPLACE.TITLE"]}
                    </div>
                }
                <div className="marketplace">
                    {this.props.marketplaceData.map((item, index)=>(
                        <RecoItem
                            key={index}
                            details={item}
                            selfInstallEnabled={this.props.selfInstallEnabled}
                            marketplaceCTAEnabled={this.props.marketplaceCTAEnabled}
                            translations={this.props.translations.data}
                            openPurchaseLink={(itemLink)=>this.props.openPurchaseLink(itemLink)}
                            colorsData={colorsData}
                            applianceList={this.props.applianceList}
                            insightBulbImage={this.props.insightBulbImage}
                            marketPlaceInsightEnabled={this.props.marketPlaceInsightEnabled}
                            productEducationEnabled={this.props.productEducationEnabled}
                            handleCTAClick={(recoId, link, rebateDetails) => this.props.handleCTAClick(recoId, link, rebateDetails)}/>
                    )
                    )}
                </div>
            </>

        )
    }

}

export default Marketplace;
